document.addEventListener('turbo:load', () => {
  const dataLayerPush = (options, eventType) => {
    if (typeof dataLayer !== 'undefined') {
      var dataLayerObject = Object.assign({}, { eventType: eventType }, options);
      dataLayer.push(dataLayerObject);
    }
  };

  const dataLayers = Array.from(document.querySelectorAll('[data-layer]'));
  dataLayers.forEach(element => {
    const options = JSON.parse(element.dataset.layer);
    const eventType = options.eventType || 'click';
    const push = JSON.parse(options.push);
    element.addEventListener(eventType, () => dataLayerPush(push, eventType));

    if (options.pushGA) {
      const pushGA = JSON.parse(options.pushGA);
      if (pushGA.event)
        element.addEventListener(eventType, () => dataLayerPush(pushGA, eventType));
    }
  });
});
